import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Oshee } from "../models/SearchService/oshee.model";

@Injectable({
  providedIn: "root"
})
export class OsheeHttpClientService {
  private readonly base = environment.backendBaseUrl;
  private readonly endpoint = "/api/oshee";
  private readonly fullPath = `${this.base}${this.endpoint}`;
  private readonly searchURL = `${this.fullPath}/search`;
  private readonly CCURL = `${this.fullPath}/start-cc`;
  private readonly walletURL = `${this.fullPath}/payment/web`;

  constructor(private http: HttpClient) {}

  Search(
    customerNumber: string,
    isAktMarreveshje: boolean,
    invoiceNumber: string,
    instanceName: string
  ) {
    const params = new HttpParams()
      .set("customerNumber", customerNumber)
      .append("isAktMarreveshje", isAktMarreveshje ? "1" : "0")
      .append("invoiceNumber", invoiceNumber)
      .append("instanceName", instanceName);

    return this.http.get<Oshee[]>(this.searchURL, {
      params
    });
  }

  PayCC(invoice: any) {
    return this.http.post<any>(`${this.CCURL}`, invoice);
  }

  PayWallet(invoice: any) {
    return this.http.post<any>(`${this.walletURL}`, invoice);
  }
}
